import * as tslib_1 from "tslib";
import { AbstractSearchCriteria } from './abstract-search-criteria';
var LeaveSearchCriteria = /** @class */ (function (_super) {
    tslib_1.__extends(LeaveSearchCriteria, _super);
    function LeaveSearchCriteria() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.resourceType = '';
        return _this;
    }
    return LeaveSearchCriteria;
}(AbstractSearchCriteria));
export { LeaveSearchCriteria };
